//? Archieved Report
import ArchievedReport from '../pages/LearningAndDevelopment/Report/ArchievedReport'

import CategoryStatus from '../pages/UploadStatus/CategoryStatus'
import CategoryOverviewTable from '../pages/UploadStatus/OverviewTable/CategoryOverviewTable'
import SalesStatus from '../pages/UploadStatus/SalesStatus'
import SalesOverviewTable from '../pages/UploadStatus/OverviewTable/SalesOverviewTable'
import ProductOverviewTable from '../pages/UploadStatus/OverviewTable/ProductOverviewTable'
import SubCategoryOverviewTable from '../pages/UploadStatus/OverviewTable/SubCategoryOverviewTable'
import ProductStatus from '../pages/UploadStatus/ProductStatus'
import SubCategoryStatus from '../pages/UploadStatus/SubCategoryStatus'
import UploadStatus from '../pages/UploadStatus/UploadStatus'
import { routeArray, textArray } from './otherHelper'
import RegionStatus from '../pages/UploadStatus/StatusTables/RegionStatus'
import RegionOverviewTable from '../pages/UploadStatus/OverviewTable/RegionOverviewTable'
import EmployeeOverviewTable from '../pages/UploadStatus/OverviewTable/EmployeeOverviewTable'
import EmployeeStatus from '../pages/UploadStatus/StatusTables/EmployeeStatus'
import ZoneStatus from '../pages/UploadStatus/StatusTables/ZoneStatus'
import StateStatus from '../pages/UploadStatus/StatusTables/StateStatus'
import DistrictStatus from '../pages/UploadStatus/StatusTables/DistrictStatus'
import CityStatus from '../pages/UploadStatus/StatusTables/CityStatus'
import AreaStatus from '../pages/UploadStatus/StatusTables/AreaStatus'
import StoreStatus from '../pages/UploadStatus/StatusTables/StoreStatus'
import ZoneOverViewTable from '../pages/UploadStatus/OverviewTable/ZoneOverViewTable'
import StateOverViewTable from '../pages/UploadStatus/OverviewTable/StateOverViewTable'
import DistrictOverViewTable from '../pages/UploadStatus/OverviewTable/DistrictOverViewTable'
import CityOverViewTable from '../pages/UploadStatus/OverviewTable/CityOverViewTable'
import AreaOverViewTable from '../pages/UploadStatus/OverviewTable/AreaOverViewTable'
import StoreOverViewTable from '../pages/UploadStatus/OverviewTable/StoreOverViewTable'
import TargetStatus from '../pages/UploadStatus/StatusTables/TargetStatus'
import TargetOverviewTable from '../pages/UploadStatus/OverviewTable/TargetOverviewTable'
import SchemeOverviewTable from '../pages/UploadStatus/OverviewTable/SchemeOverviewTable'
import SchemeStatus from '../pages/UploadStatus/StatusTables/SchemeStatus'
import EditPermission from '../pages/Permission/EditPermission'
import ViewPermission from '../pages/Permission/ViewPermission'
import Companies from '../SuperAdmin/Company/Companies'
import AddCompany from '../SuperAdmin/Company/AddCompany'
import EditCompany from '../SuperAdmin/Company/EditCompany'
import ViewCompany from '../SuperAdmin/Company/ViewCompany'
import SuperAdmins from '../SuperAdmin/OtherSuperAdmin/SuperAdmins'
import AddSuperAdmin from '../SuperAdmin/OtherSuperAdmin/AddSuperAdmin'
import EditSuperAdmin from '../SuperAdmin/OtherSuperAdmin/EditSuperAdmin'
import ViewSuperAdmin from '../SuperAdmin/OtherSuperAdmin/ViewSuperAdmin'
import TrainingCategory from '../pages/LearningAndDevelopment/TrainingCategory/TrainingCategories'
import AddTrainingCategory from '../pages/LearningAndDevelopment/TrainingCategory/AddTrainingCategory'
import AddTrainingCategoryContent from '../pages/LearningAndDevelopment/TrainingCategoryContent/AddTrainingCategoryContent'
import EditTrainingCategory from '../pages/LearningAndDevelopment/TrainingCategory/EditTrainingCategory'
import ViewTrainingCategory from '../pages/LearningAndDevelopment/TrainingCategory/ViewTrainingCategory'
import TrainingCategoryContent from '../pages/LearningAndDevelopment/TrainingCategoryContent/TrainingCategoryContent'
import EditTrainingCategoryContent from '../pages/LearningAndDevelopment/TrainingCategoryContent/EditTrainingCategoryContent'
import ViewTrainingCategoryContent from '../pages/LearningAndDevelopment/TrainingCategoryContent/ViewTrainingCategoryContent'
import Quiz from '../pages/LearningAndDevelopment/Quiz/Quiz'
import ViewQuiz from '../pages/LearningAndDevelopment/Quiz/ViewQuiz'
import AddTQuiz from '../pages/LearningAndDevelopment/Quiz/AddQuiz'
import EditQuiz from '../pages/LearningAndDevelopment/Quiz/EditQuiz'
import UploadHeaders from '../pages/Masters/UploadHeader/UploadHeaders'
import ViewUploadHeader from '../pages/Masters/UploadHeader/ViewUploadHeader'
import AddUploadHeader from '../pages/Masters/UploadHeader/AddUploadHeader'
import EditUploadHeader from '../pages/Masters/UploadHeader/EditUploadHeader'
import SftpOverviewTable from '../pages/UploadStatus/OverviewTable/SftpOverviewTable'
import SftpStatusTable from '../pages/UploadStatus/StatusTables/SftpStatusTable'
import AuditQuestion from '../pages/Audit/Questions/AuditQuestion'
import ViewAuditQuestions from '../pages/Audit/Questions/ViewAuditQuestions'
import Task from '../pages/Audit/Task/Tasks'
import AddTask from '../pages/Audit/Task/AddTask'
import EditTask from '../pages/Audit/Task/EditTask'
import AuditScores from '../pages/Audit/AuditScores/AuditScores'
import AuditTask from '../pages/Audit/AuditTasks/AuditTasks'
import PosTask from '../pages/Audit/Pos/PosTask'
import AddPosTask from '../pages/Audit/Pos/AddPosTask'
import EditPosTask from '../pages/Audit/Pos/EditPosTask'
import Reward from '../pages/Reward/Reward'
import AuditDashboard from '../pages/Audit/AuditDashboard'
import OpenAuditTaskReport from '../pages/Audit/Reports/OpenAuditTaskReport'
import OpenPosTaskReport from '../pages/Audit/Reports/OpenPosTaskReport'
import AuditReport from '../pages/Audit/Reports/AuditReport'
import InductionReport from '../pages/LearningAndDevelopment/Report/InductionReport'
import ContentReport from '../pages/LearningAndDevelopment/Report/ContentReport'
import ActiveContentReport from '../pages/LearningAndDevelopment/Report/ActiveContentReport'
import LearningScoreReport from '../pages/LearningAndDevelopment/Report/LearningScoreReport'
import QuizReport from '../pages/LearningAndDevelopment/Report/QuizReport'
import LeaderBoardReport from '../pages/Reward/LeaderBoardReport'
import TopKbcReport from '../pages/Reward/TopKbcReport'
import Permissions from '../pages/Permission/Permissions'
import ModuleAdmins from '../pages/ModuleAdmin/ModuleAdmins'
import AddModuleAdmin from '../pages/ModuleAdmin/AddModuleAdmin'
import EditModuleAdmin from '../pages/ModuleAdmin/EditModuleAdmin'
import ViewModuleAdmin from '../pages/ModuleAdmin/ViewModuleAdmin'
import AddPermission from '../pages/Permission/AddPermission'
import AddBusinessCategory from '../pages/BusinessCategory/AddBusinessCategory'
import BusinessCategory from '../pages/BusinessCategory/BusinessCategory'
import EditBusinessCategory from '../pages/BusinessCategory/EditBusinessCategory'
import AddBusinessType from '../pages/BusinessType/AddBusinessType'
import BusinessType from '../pages/BusinessType/BusinessType'
import EditBusinessType from '../pages/BusinessType/EditBusinessType'
import AddAllowanceType from '../pages/AllowanceType/AddAllowanceType'
import EditAllowanceType from '../pages/AllowanceType/EditAllowanceType'
import AllowanceType from '../pages/AllowanceType/AllowanceType'
import AddTravelCategory from '../pages/TravelCategory/AddTravelCategory'
import EditTravelCategory from '../pages/TravelCategory/EditTravelCategory'
import TravelCategory from '../pages/TravelCategory/TravelCategory'
import AddSubscription from '../SuperAdmin/SubscriptionsPlans/AddSubscriptions'
import CompanyActiveSubscription from '../SuperAdmin/SubscriptionsPlans/CompanyActiveSubscriptions'
//? Travel Requests
import TravelRequests from '../pages/TravelRequests/TravelRequests'
import AddTravelRequest from '../pages/TravelRequests/AddTravelRequest'
import EditTravelRequest from '../pages/TravelRequests/EditTravelRequest'
//?
import AllowanceTypes from '../pages/Masters/AllowanceTypes'
import BeatPlans from '../pages/Beat/Beat'
import AddBeatPlan from '../pages/Beat/AddBeatPlan'
import DealerOnboardingRequests from '../pages/Dealer/DealerOnboardingRequests'
import AddDealer from '../pages/Dealer/AddDealer'

import AddChannelTypeMaster from '../pages/ChannelTypeMaster/AddChannelTypeMaster'
import ChannelTypeMaster from '../pages/ChannelTypeMaster/ChannelTypeMaster'
import EditChannelTypeMaster from '../pages/ChannelTypeMaster/EditChannelTypeMaster'
import Subscriptions from '../SuperAdmin/SubscriptionsPlans/SubscriptionsPlans'
import ActiveSubscriptions from '../SuperAdmin/ActiveSubscriptions/ActiveSubscriptions'



import SuperAdminPermissions from '../SuperAdmin/Permissions/Permissions'
import AddSuperPermissions from '../SuperAdmin/Permissions/AddSuperPermissions'



const pageArray = [
  CategoryOverviewTable,
  SubCategoryOverviewTable,
  ProductOverviewTable,
  EmployeeOverviewTable,
  SalesOverviewTable,
  RegionOverviewTable,
  ZoneOverViewTable,
  StateOverViewTable,
  DistrictOverViewTable,
  CityOverViewTable,
  AreaOverViewTable,
  StoreOverViewTable,
  TargetOverviewTable,
  SchemeOverviewTable,
  SftpOverviewTable,
]
const otherPageArray = [
  UploadStatus,
  CategoryStatus,
  SubCategoryStatus,
  ProductStatus,
  EmployeeStatus,
  SalesStatus,
  RegionStatus,
  ZoneStatus,
  StateStatus,
  DistrictStatus,
  CityStatus,
  AreaStatus,
  StoreStatus,
  TargetStatus,
  SchemeStatus,
  SftpStatusTable,
]

let otherRouteArray = ['UPLOAD_STATUS']
textArray.map((val) => {
  return otherRouteArray.push(`${val}_STATUS`)
})

const tempArray = routeArray.map((val, index) => {
  return { route: val, page: pageArray[index] }
})

const otherTempArray = otherRouteArray.map((val, index) => {
  return { route: val, page: otherPageArray[index] }
})

const extraRoutes = []

export const routes = [...tempArray, ...otherTempArray, ...extraRoutes]
// export const superAdminRoute = [
//   'ALL_COMPANIES',
//   'ADD_COMPANY',
//   'VIEW_COMPANY',
//   'EDIT_COMPANY',
//   'ALL_SUPERADMINS',
//   'ADD_SUPERADMIN',
//   'VIEW_SUPERADMIN',
//   'EDIT_SUPERADMIN',
//   'ALL_UPLOAD_HEADERS',
//   'ADD_UPLOAD_HEADER',
//   'VIEW_UPLOAD_HEADER',
//   'EDIT_UPLOAD_HEADER',
// ]
// export const superAdminPage = [
//   Companies,
//   AddCompany,
//   ViewCompany,
//   EditCompany,
//   SuperAdmins,
//   AddSuperAdmin,
//   ViewSuperAdmin,
//   EditSuperAdmin,

//   UploadHeaders,
//   AddUploadHeader,
//   ViewUploadHeader,
//   EditUploadHeader,
//   // AddUploadHeader, ViewUploadHeader, EditUploadHeader
// ]

export const superAdminRoute = [
  'ALL_COMPANIES',
  'ADD_COMPANY',
  'VIEW_COMPANY',
  'EDIT_COMPANY',
  'ALL_SUPERADMINS',
  'ALL_SUBSCRIPTION_PLANS', //? ALL SUBSCRIPTION PLANS
  'ADD_SUBSCRIPTION_PLAN',
  'EDIT_SUBSCRIPTION_PLAN',
  'ACTIVE_SUBSCRIPTIONS',
  'COPMANY_SUBSCRIPTION',
  'ADD_SUPERADMIN',
  'VIEW_SUPERADMIN',
  'EDIT_SUPERADMIN',
  'ALL_TRAININGCATEGORY',
  'ADD_TRAININGCATEGORY',
  'VIEW_TRAININGCATEGORY',
  'EDIT_TRAININGCATEGORY',
  'ALL_TRAININGCATEGORYCONTENT',
  'ADD_TRAININGCATEGORYCONTENT',
  'VIEW_TRAININGCATEGORYCONTENT',
  'EDIT_TRAININGCATEGORYCONTENT',
  'ALL_CONTENTQUESTION',
  'ADD_CONTENTQUESTION',
  'VIEW_CONTENTQUESTION',
  'EDIT_CONTENTQUESTION',
  'ALL_UPLOAD_HEADERS',
  'ADD_UPLOAD_HEADER',
  'VIEW_UPLOAD_HEADER',
  'EDIT_UPLOAD_HEADER',
  'ALL_AUDITQUESTION',
  'VIEW_AUDITQUESTION',
  'ALL_TASK',
  'ADD_TASK',
  'EDIT_TASK',
  'ALL_AUDITSCORE',
  'ALL_AUDIT_TASK',
  'ALL_POS_TASK',
  'ADD_POS_TASK',
  'EDIT_POS_TASK',
  'ALL_REWARD',
  'AUDIT_DASHBOARD',
  'OpenAuditTaskReport',
  'OpenPosTaskReport',
  'GET_AUDIT_REPORT',
  'GET_ARCHIEVED_REPORT',
  'GET_INDUCTION_REPORT',
  'GET_CONTENT_REPORT',
  'GET_ACTIVE_CONTENT_REPORT',
  'GET_LEARNING_SCORE_CARD_REPORT',
  'GET_QUIZ_REPORT',
  'GET_LEADER_BOARD_REPORT',
  'GET_TOP_KBC_REPORT',
  'ALL_PERMISSIONS',
  'ADD_PERMISSION',
  'EDIT_PERMISSION',
  'VIEW_PERMISSION',
  'ALL_MODULEADMINS',
  'ADD_MODULEADMIN',
  'EDIT_MODULEADMIN',
  'VIEW_MODULEADMIN',
  // 'ALL_MODULEADMINS',
  'ADD_BUSINESS_CATEGORY',
  'EDIT_BUSINESS_CATEGORY',
  'BUSINESS_CATEGORY',

  'ADD_BUSINESS_TYPE',
  'EDIT_BUSINESS_TYPE',
  'BUSINESS_TYPE',

  'ADD_ALLOWANCE_TYPE',
  'EDIT_ALLOWANCE_TYPE',
  'ALLOWANCE_TYPE',

  'ADD_TRAVEL_CATEGORY',
  'EDIT_TRAVEL_CATEGORY',
  'TRAVEL_CATEGORY',

  'TRAVEL_REQUESTS',
  'ADD_TRAVEL_REQUESTS',
  'EDIT_TRAVEL_REQUESTS',
  // 'BEAT_PLANS',
  // 'ADD_BEAT_PLAN',
  'DEALER_ONBOARDING',
  'ADD_DEALER_ONBOARDING',
  'EDIT_DEALER_ONBOARDING',


  'ADD_CHANNEL_TYPE_MASTER',
  'EDIT_CHANNEL_TYPE_MASTER',
  'CHANNEL_TYPE_MASTER',

  // 'ADD_PERMISSIONS',
  // 'EDIT_PERMISSIONS',
  'PERMISSIONS',
  'ADD_SUPER_ADMIN_PERMISSIONS',
  'EDIT_SUPER_ADMIN_PERMISSIONS'
]
export const superAdminPage = [
  Companies,
  AddCompany,
  ViewCompany,
  EditCompany,
  SuperAdmins,
  Subscriptions, //? Subscription Plans
  AddSubscription, 
  AddSubscription,
  ActiveSubscriptions,
  CompanyActiveSubscription,
  AddSuperAdmin,
  ViewSuperAdmin,
  EditSuperAdmin,
  TrainingCategory,
  AddTrainingCategory,
  ViewTrainingCategory,
  EditTrainingCategory,
  TrainingCategoryContent,
  AddTrainingCategoryContent,
  ViewTrainingCategoryContent,
  EditTrainingCategoryContent,
  Quiz,
  AddTQuiz,
  ViewQuiz,
  EditQuiz,
  UploadHeaders,
  AddUploadHeader,
  ViewUploadHeader,
  EditUploadHeader,
  AuditQuestion,
  ViewAuditQuestions,
  Task,
  AddTask,
  EditTask,
  AuditScores,
  AuditTask,
  PosTask,
  AddPosTask,
  EditPosTask,
  Reward,
  AuditDashboard,
  OpenAuditTaskReport,
  OpenPosTaskReport,
  AuditReport,
  ArchievedReport,
  InductionReport,
  ContentReport,
  ActiveContentReport,
  LearningScoreReport,
  QuizReport,
  LeaderBoardReport,
  TopKbcReport,
  Permissions,
  AddPermission,
  EditPermission,
  ViewPermission,
  ModuleAdmins,
  AddModuleAdmin,
  EditModuleAdmin,
  ViewModuleAdmin,
  AddBusinessCategory,
  EditBusinessCategory,
  BusinessCategory,
  AddBusinessType,
  EditBusinessType,
  BusinessType,
  AddAllowanceType,
  EditAllowanceType,
  AllowanceType,
  AddTravelCategory,
  EditTravelCategory,
  TravelCategory,
  
  TravelRequests,
  AddTravelRequest,
  EditTravelRequest,
  // BeatPlans,
  // AddBeatPlan,
  DealerOnboardingRequests,
  AddDealer,
  AddDealer,
  AddChannelTypeMaster,
  EditChannelTypeMaster,
  ChannelTypeMaster,

  SuperAdminPermissions,
  AddSuperPermissions,
  AddSuperPermissions,
]

export const superAdminRoutes = superAdminRoute.map((val, index) => {
  // console.log({ route: val, page: superAdminPage[index] })
  return { route: val, page: superAdminPage[index] }
})
